import './App.css';
import {ListItem} from './components/ListItem'
import {Home} from './components/Home'
export default function App() {
    
    return (
      <div>
        <main>
          <section className="container">          
            <ListItem texto={"Home"} />
            <Home
              imagem={require("./camiseta_ecommerce.jpg")}
              nome={"Camiseta Geek"}
              preço={"R$18,00"}
            />
            <Home
              imagem={require("./camiseta_ecommerce.jpg")}
              nome={"Camiseta Geek"}
              preço={"R$18,00"}
            />
            <Home
              imagem={require("./camiseta_ecommerce.jpg")}
              nome={"Camiseta Geek"}
              preço={"R$18,00"}
            />
            <Home
              imagem={require("./camiseta_ecommerce.jpg")}
              nome={"Camiseta Geek"}
              preço={"R$18,00"}
            />
            <Home
              imagem={require("./camiseta_ecommerce.jpg")}
              nome={"Camiseta Geek"}
              preço={"R$18,00"}
            />
          </section>
        </main>
        <nav>
          <ul>
            <li className="cabecalho-box">
                <a href="#index.html">GeekECommerce</a>
            </li>
          </ul>
        </nav>
      <footer>
        <h1>Olá! Estou no Footer!</h1>
      </footer>
        
      </div>
    );

  }
  

